import { Router } from "vue-router";
import NProgress from "nprogress";

import { PUBLIC_RT } from "@/router/white";

export function permission(router: Router | undefined) {
  if (router) {
    router.beforeEach(async (to, from, next) => {
      if (PUBLIC_RT.includes(to.name!)) {
        next();
      } else {
        NProgress.start();
        next();
      }
    });
    router.afterEach(() => {
      NProgress.done();
    });
  }
}

NProgress.configure({
  easing: "ease", // 动画方式
  speed: 500, // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.3 // 初始化时的最小百分比
});
